jQuery(document).ready(function () {
    /*****
     * smartresize when resize screen
     *****/
    _window.smartresize(function () {
        /* re-calc viewport Width & Height */
        viewportW = _window.width();
        viewportH = _window.height();
    });

    /* menu smp */
    var header_scroll_class = '_small';

    /* header small */
    jQuery(window).on('scroll', function (e) {
        if (jQuery(window).scrollTop() > 100)
            jQuery('#header').addClass(header_scroll_class);
        else jQuery('#header').removeClass(header_scroll_class);
    });

    /*! zoom img on SMP !*/
    var smp_zoom = jQuery('.smp_zoom');
    if (smp_zoom.length > 0 && viewportW <= viewportSMP) {
        smp_zoom.each(function () {
            jQuery(this).wrap('<a data-fancybox href="' + jQuery(this).attr('src') + '"></a>');
        });
    }

    /* check element in view */
    var in_view = jQuery('[class*="inview-"]');
    if (in_view.length > 0) {
        in_view.on('inview', function (event, isInView) {
            if (isInView)
                jQuery(this).addClass('inview-active');
        });
    }

    /* fancybox */
    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    });

    /* main visual */
    setTimeout(function () {
        var main_visual = jQuery('.main_visual');
        if (main_visual.length > 0) {
            // background image
            var mainvisual_image = is_smp ? main_visual.data('imgsmp') : main_visual.data('imgpc');
            main_visual.css('background-image', 'url(' + mainvisual_image + ')');
        }
    }, 500);

    /* introduction_galleries scroll */
    var introduction_galleries = jQuery('.introduction_galleries');
    if (introduction_galleries.length > 0) {
        introduction_galleries.each(function () {
            var _this_scroll = jQuery(this).find('.introduction_galleries_scroll');
            var _this_scroll_length = _this_scroll.find('div').length;
            var _this_scroll_content = _this_scroll.html();
            var speed = jQuery(this).data('speed') || _this_scroll_length * 5000;
            _this_scroll.remove();
            jQuery(this).append(
                '<div class="introduction_galleries_scroll" style="animation-duration:' + speed + 'ms;">' + _this_scroll_content + '</div>' +
                '<div class="introduction_galleries_scroll" style="animation-duration:' + speed + 'ms;">' + _this_scroll_content + '</div>'
            );
        });
    }

    /* menu smp */
    var menu_smp = jQuery('.menu_smp');
    menu_smp.on('click', function () {
        jQuery(this).parents('header').toggleClass('active');
        jQuery(this).next().slideToggle().toggleClass('_open');
    });

    /* footer banners slider */
    const footer_banners_swiper = new Swiper('.footer_banners', {
        slidesPerView: 2,
        spaceBetween: 10,
        // centeredSlides: true,
        loop: true,
        autoplay: {
            delay: 5000,
        },
        breakpoints: {
            769: {
                slidesPerView: 6,
                centeredSlides: false,
            },
        },
    });
});